import type { TOC } from '@ember/component/template-only'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { PageHeaderReturnLink } from 'teacher-ui-client/components/page-header/return-link'
import { t } from 'ember-intl'
import { CsvToRecords } from 'teacher-ui-client/components/csv-to-records'
import RouteTemplate from 'ember-route-template'

export const ManageImportTeachersPage: TOC<unknown> = <template>
  <PageHeader>
    <:title>
      <h1>
        {{t "manage.teachers.bulkActions.csv.title"}}
      </h1>
    </:title>
    <:left>
      <PageHeaderReturnLink @route="manage.teachers">
        {{t "manage.manageTeachers.returnLink"}}
      </PageHeaderReturnLink>
    </:left>
  </PageHeader>
  <CsvToRecords />
</template>

export default RouteTemplate(ManageImportTeachersPage)
